import React from "react";
import {
  Modal,
  Stack,
  TextInput,
  Button,
  Group,
  Text,
  Tooltip,
  ActionIcon,
  List,
} from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";

function DeviceRegistrationModal({
  opened,
  onClose,
  onSubmit,
  deviceData,
  setDeviceData,
  isLoading,
}) {
  return (
    <Modal opened={opened} onClose={onClose} title="Register New Device">
      <Stack>
        <TextInput
          label="Terminal Name"
          description="Shown at checkout to identify this terminal (e.g. Front Desk). You can rename it later."
          placeholder="Front Desk"
          maxLength={100}
          value={deviceData.label}
          onChange={(e) =>
            setDeviceData({ ...deviceData, label: e.target.value })
          }
          required
        />
        <TextInput
          label={
            <Group gap={4} align="center">
              <Text span c="#666666" size="sm">
                Registration Code
              </Text>
              <Text span c="red">
                *
              </Text>
              <Tooltip
                label={
                  <Stack gap="xs">
                    <Text size="sm" fw={500}>
                      To obtain the registration code for your WisePOS E card
                      reader:
                    </Text>
                    <List
                      gap="xs"
                      size="sm"
                      type="ordered"
                      styles={(theme) => ({
                        item: {
                          color: theme.colors.gray[7],
                        },
                      })}
                    >
                      <List.Item>Swipe right on the touchscreen</List.Item>
                      <List.Item>Tap "Settings"</List.Item>
                      <List.Item>Enter the admin PIN "07139"</List.Item>
                      <List.Item>
                        Tap "Generate Pairing Code" to display the three-word
                        code
                      </List.Item>
                    </List>
                  </Stack>
                }
                position="top-start"
                width={300}
                multiline
                p="md"
                color="white"
                withArrow={false}
                variant="filled"
                radius="sm"
                bd="1px solid #e9ecef"
              >
                <ActionIcon variant="subtle" size="sm">
                  <IconInfoCircle size="1rem" style={{ cursor: "help" }} />
                </ActionIcon>
              </Tooltip>
            </Group>
          }
          placeholder="Enter the code shown on your device"
          value={deviceData.registrationCode}
          onChange={(e) =>
            setDeviceData({ ...deviceData, registrationCode: e.target.value })
          }
          required
          withAsterisk={false}
        />
        <Button
          onClick={onSubmit}
          color="teal"
          fullWidth
          mt="md"
          loading={isLoading}
        >
          Register Device
        </Button>
      </Stack>
    </Modal>
  );
}

export default DeviceRegistrationModal;
